/**
 * Generato automaticamente.
 * framework-cmp-domande
 */

export type CollegamentoRichiestaDTODirezione =
  (typeof CollegamentoRichiestaDTODirezione)[keyof typeof CollegamentoRichiestaDTODirezione];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CollegamentoRichiestaDTODirezione = {
  ENTRATA: 'ENTRATA',
  USCITA: 'USCITA',
} as const;
